module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/tokyu-livable-e4c6c5197b7efed2f64e022f5f0e356c.png";